import PropTypes from 'prop-types';
import { rangeValidator } from '../../../utils/utilities';
const betweenOneToTwelve = rangeValidator({ min: 1, max: 12 });
export const OtpInputPropTypes = {
    /** Number of input characters Int (1 - 12)*/
    otpLength: betweenOneToTwelve,
    /** Boolean */
    disabled: PropTypes.bool,
    /** Boolean (Toggle color) */
    isInvalid: PropTypes.bool,
    /** Callback (Call when otp is completed that return a value) */
    onComplete: PropTypes.func,
    /** Callback (Call when otp value has changed) */
    handleChange: PropTypes.func,
    /** Boolean (Focus when component is mounted) */
    shouldAutoFocus: PropTypes.bool,
    /** Boolean (Disable individual input manage) */
    controlledMode: PropTypes.bool,
    maxLength: PropTypes.number,
    onChange: PropTypes.func,
    onKeyPress: PropTypes.func,
    onKeyDown: PropTypes.func,
    value: PropTypes.string,
    hintMessage: PropTypes.string,
    errorMessage: PropTypes.string,
    denyInvalidFilled: PropTypes.bool
};
export const OtpInputDefaultProps = {
    otpLength: 6,
    disabled: false,
    isInvalid: false,
    shouldAutoFocus: true
};
//# sourceMappingURL=OtpInput.prop-types.js.map